
    var riot = require('riot')
    import { Icon } from './gb-icon';
riot.tag2('gb-icon', '<i if="{classes}" class="{classes}"></i> <img if="{url}" riot-src="{url}"></img>', '', '', function(opts) {
    this._mixin(Icon);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/icon/gb-icon.tag.html